export enum SystemType {
  WINDOW = "WINDOW",
  LIFTING_SLIDING_DOOR = "LIFTING_SLIDING_DOOR",
  FRONT_DOOR = "FRONT_DOOR",
  GARAGE_DOOR = "GARAGE_DOOR",
}
